/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

type Props = {
    title?: string
    description?: string
}

const Primary = ({ title, description }: Props) => {
    return (
        <div className="py-20 py-24 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 text-center">
            <h1 className="text-gray-200 font-semibold text-4xl leading-tight mb-4">{title}</h1>
            <p className="text-gray-300 text-xl">{description}</p>
        </div>
    )
}

export default Primary